import { DatePicker, TimePicker } from 'antd';
import React from 'react';

const InspectionRecordList: React.FC = () => {
  const items = [
    { title: 'Iluminação Interna e Externa' },
    {
      title: 'Calibragem dos Pneus',
      render: (
        <table className="table-render">
          <thead>
            <tr>
              <th>Dianterios</th>
              <th>Traseiros</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              {Array.from({ length: 2 }).map((_, index) => (
                <td key={index}>
                  <div style={{ display: 'flex' }}>
                    <input type="text" style={{ width: 222 }} />
                  </div>
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      ),
      height: 40,
    },
    {
      title: 'Níveis e Fluídos',
      render: (
        <table className="table-render">
          <thead>
            <tr>
              <th>Água</th>
              <th>Óleo</th>
              <th>Freio</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              {Array.from({ length: 3 }).map((_, index) => (
                <td key={index}>
                  <div style={{ display: 'flex' }}>
                    <input type="text" style={{ width: 147 }} />
                  </div>
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      ),
      height: 40,
    },
    {
      title: 'Avarias e falhas apagados?',
      render: (
        <table className="table-render">
          <tbody>
            <tr>
              <th style={{ border: 'none' }}>
                <div
                  className="list-only-checkbox"
                  style={{ padding: '0 24px' }}
                >
                  <div>
                    <label>
                      <input type="checkbox" />
                      <span>Sim</span>
                    </label>

                    <label>
                      <input type="checkbox" />
                      <span>Não</span>
                    </label>
                  </div>
                </div>
              </th>

              <table className="table-render">
                <thead>
                  <tr>
                    <th>Porque?</th>
                  </tr>
                </thead>

                <tbody>
                  <td>
                    <div>
                      <input type="text" style={{ width: 344, height: 30 }} />
                    </div>
                  </td>
                </tbody>
              </table>
            </tr>
          </tbody>
        </table>
      ),
      height: 40,
    },
    { title: 'As solicitações do cliente foram atendidas?' },
    { title: 'Etiqueta de óleo' },
    { title: 'Torquear as Rodas' },
    {
      title: 'Serviço Pendente?',
      render: (
        <table className="table-render">
          <thead>
            <tr>
              <th>Qual?</th>
              <th>Ag. Peça?</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              {Array.from({ length: 2 }).map((_, index) => (
                <td key={index}>
                  <div style={{ display: 'flex' }}>
                    <input type="text" style={{ width: 250 }} />
                  </div>
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      ),
      height: 40,
    },
    { title: 'Data e Hora' },
    {
      title: 'Teste de Rodagem',
      render: (
        <table className="table-render">
          <thead>
            <tr>
              <th>Data</th>
              <th>Hora</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div style={{ display: 'flex' }}>
                  <DatePicker
                    placeholder=""
                    style={{ width: 250 }}
                    format="DD/MM/YYYY"
                  />
                </div>
              </td>
              <td>
                <div style={{ display: 'flex' }}>
                  <TimePicker
                    placeholder=""
                    style={{ width: 250 }}
                    format="HH:mm:ss"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <label>Assinatura do piloto de teste:</label>
                  <input type="text" style={{ width: '100%', height: 40 }} />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      ),
    },
    { title: 'Limpeza Externa' },
    { title: 'Limpeza Interna' },
  ];

  return (
    <>
      {items.map((item, index) => (
        <table style={{ marginBottom: 8 }}>
          <tbody>
            <tr key={index}>
              <th>
                <div className="list-only-checkbox">
                  <div>
                    <label>
                      <input type="checkbox" />
                      <span>{item.title}</span>
                    </label>
                  </div>

                  <div>{item.render}</div>
                </div>
              </th>
            </tr>
          </tbody>
        </table>
      ))}
    </>
  );
};

export default InspectionRecordList;
